import { CLASS_NAMES } from "../../utils/constants"

export default class BaseObject {
  constructor() {
    this.eventListeners = []
    this.classes = [] // helper fot isClass matching
  }

  listClasses() {
    let proto = this.__proto__
    const classes = []
    while(proto.constructor.className !== undefined) {
      classes.push(proto.constructor.className)
      proto = proto.__proto__
    }
    return classes
  }

  isClass(givenClass) {
    if(this.classes.length === 0) {
      this.classes = this.listClasses()
    }
    const className = typeof givenClass === 'string' ? givenClass : givenClass.className
    return this.classes.includes(className)
    
    // if(Class.className === 'Player') {
    //   window.test = this
    // }
    // return this.constructor.className === Class.className
  }
  addEventListener(eventName, listener) {
    this.eventListeners.push([eventName, listener])
    return () => {
      this.eventListeners = this.eventListeners.filter(l => l[1] !== listener)
    }
  }
  dispatchEvent(eventName, payload) {
    this.eventListeners.filter(l => l[0] === eventName).forEach(l => l(payload, this))
  }
}

BaseObject.className = CLASS_NAMES.BASE_OBJECT